import { createSelector } from 'reselect';
import { getWidgetConfig, getQueueCounters } from '../../root/selectors';

const getUploadQueue = (state) => state.uploadQueue.queueIds.map((id) => state.uploadQueue.queueItems[id]);

const selectUploadQueueItems = createSelector(getUploadQueue, (queue) => queue);

const selectUploadQueueItemIds = createSelector(
  (state) => state.uploadQueue.queueIds,
  (ids) => ids
);

const selectCompletedIds = createSelector(getUploadQueue, (queue) =>
  queue.reduce((res, item) => (item.done && !item.failed ? res.concat(item.id) : res), [])
);

const selectQueueCounters = createSelector((state) => state.uploadQueue, getQueueCounters);

const selectIsDoneWithSuccess = createSelector(selectQueueCounters, (counters) => counters.isDone && !counters.failed);

const selectShowCompletedButton = createSelector(getWidgetConfig, (config) => config.showCompletedButton);

const selectShowUploadMoreButton = createSelector(getWidgetConfig, (config) => config.showUploadMoreButton);

const selectQueueProgress = createSelector(getUploadQueue, (queue) => {
  const progress = queue.reduce((total, item) => total + item.progress, 0);

  return progress && Math.round(progress / queue.length);
});

export {
  selectUploadQueueItemIds,
  selectUploadQueueItems,
  selectQueueCounters,
  selectCompletedIds,
  selectShowCompletedButton,
  selectShowUploadMoreButton,
  selectQueueProgress,
  selectIsDoneWithSuccess,
};
